import { gql } from 'graphql-request'

export const pdpGraphQLQuery = gql`
  query productData($handle: String!, $namespace: String!) {
    product(handle: $handle) {
      id
      description
      onlineStoreUrl
      tags
      handle
      title
      weeklyrental: metafield(namespace:$namespace, key: "weeklyrental") {
         value
      }
      rentalprice: metafield(namespace:$namespace, key: "rentalprice") {
         value
      }
      variants(first: 1) {
        edges {
          node {
            sku
          }
        }
      }
      price: priceRange {
        maxVariantPrice {
          amount
        }
      }
    }
  }
`
